const es = {
  app_name: "Univers Libertin",
  app_tagline: "Tu espacio seguro, discreto y amable.",
  app_badge: "Adultos con consentimiento · Comunidad",
  loading: "Cargando...",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  close: "cerrar",
  send: "Enviar",
  search: "Buscar",
  go: "Ir",
  confirm_delete: "¿Eliminar esta publicación?",
  no_results: "No se encontraron resultados.",
  error_generic: "Error interno.",
  footer_trust: "Privacidad total · Moderación IA · Tus datos nunca se venden",

  nav_feed: "Muro",
  nav_directory: "Directorio",
  nav_encounters: "Encuentros",
  nav_places: "Lugares",
  nav_messages: "Mensajes",
  nav_premium: "Premium",
  nav_profile: "Perfil",
  nav_blog: "Blog",
  nav_logout: "Cerrar sesión",

  age_gate_title: "Solo para adultos",
  age_gate_desc: "Univers Libertin es una plataforma comunitaria para adultos con consentimiento. El acceso está reservado a personas mayores de 18 años.",
  age_gate_confirm: "Certifico que tengo 18 años o más — Entrar",
  age_gate_deny: "Soy menor de edad — Salir",

  charter_title: "Carta de consentimiento",
  charter_desc: "Comprométase a respetar estos principios fundamentales para acceder a la comunidad.",
  charter_accept_all: "Acepto la carta — Continuar",
  charter_accept_pending: "Acepte los 3 compromisos",
  charter_rule_consent_title: "Consentimiento absoluto",
  charter_rule_consent_desc: "Afirmo ser mayor de edad (+18). Me comprometo a respetar el consentimiento de cada persona en todo momento. Un «no» o un silencio nunca es un «sí». No se tolerará ninguna presión, insistencia o manipulación.",
  charter_rule_discretion_title: "Confidencialidad total",
  charter_rule_discretion_desc: "Lo que pasa en Univers Libertin se queda en Univers Libertin. Nunca compartiré la identidad, fotos, información o actividades de otro miembro sin su consentimiento explícito.",
  charter_rule_respect_title: "Respeto y amabilidad",
  charter_rule_respect_desc: "Respeto los límites, prácticas y elecciones de cada persona sin juzgar. Ningún tipo de discriminación, body-shaming o kink-shaming será tolerado.",
  charter_read_again: "← Releer la carta",

  auth_login: "Iniciar sesión",
  auth_signup: "Registrarse",
  auth_pseudo: "Seudónimo",
  auth_pseudo_placeholder: "Tu seudónimo discreto",
  auth_pseudo_hint: "Elige un seudónimo — nunca tu nombre real.",
  auth_email: "Email",
  auth_email_placeholder: "tu@email.com",
  auth_password: "Contraseña",
  auth_password_placeholder: "Mínimo 8 caracteres",
  auth_login_btn: "Iniciar sesión",
  auth_signup_btn: "Unirse a la comunidad",
  auth_logging_in: "Conectando...",
  auth_signing_up: "Creando...",
  auth_signup_success: "¡Cuenta creada! Ya puedes iniciar sesión.",

  feed_placeholder: "¿Cómo te sientes? Comparte con seguridad...",
  feed_publish: "Publicar",
  feed_analyzing: "Analizando...",
  feed_char_count: "{count}/2000 — Moderado por IA",
  feed_empty: "No hay publicaciones aún. Sé el/la primero/a en compartir.",
  feed_moderation_warning: "Tu mensaje no cumple con nuestra carta.",

  mood_neutral: "Neutro",
  mood_happy: "Feliz",
  mood_sad: "Triste",
  mood_anxious: "Ansioso/a",
  mood_grateful: "Agradecido/a",
  mood_angry: "Enfadado/a",
  mood_hopeful: "Esperanzado/a",

  directory_title: "Directorio",
  directory_desc: "Explora la comunidad con discreción.",
  directory_search_placeholder: "Buscar por ciudad...",
  directory_filter_all: "Todos",
  directory_no_profiles: "No se encontraron perfiles.",
  directory_send_message: "Enviar un mensaje →",
  directory_looking_for: "Busca:",
  directory_interests: "Intereses:",

  filter_gender: "Género",
  filter_orientation: "Orientación",
  filter_status: "Situación",
  filter_all_genders: "Todos",
  filter_all_orientations: "Todas",
  filter_all_statuses: "Todos",

  gender_unset: "No especificado", gender_man: "Hombre", gender_woman: "Mujer", gender_nb: "No binario", gender_other: "Otro",
  orientation_unset: "No especificado", orientation_hetero: "Hetero", orientation_bi: "Bi", orientation_gay: "Gay", orientation_lesbian: "Lesbiana", orientation_pan: "Pan", orientation_curious: "Curioso/a", orientation_other: "Otro",
  status_unset: "No especificado", status_solo: "Solo/a", status_couple: "En pareja", status_open: "Pareja abierta", status_poly: "Poliamoroso/a", status_other: "Otro",
  level_unset: "No especificado", level_curious: "Curioso/a", level_beginner: "Principiante", level_experienced: "Experimentado/a", level_confirmed: "Avanzado/a",

  profile_title: "Mi perfil", profile_desc: "Personaliza tu presencia. Solo tu seudónimo es visible, nunca tu email.",
  profile_avatar: "Avatar", profile_photos: "Fotos de perfil",
  profile_photos_hint: "Puedes difuminar algunas fotos. Hazte Premium para subir más.",
  profile_identity: "Identidad", profile_display_name: "Nombre visible", profile_display_name_placeholder: "Apodo",
  profile_bio: "Bio", profile_bio_placeholder: "Descríbete, tus deseos, lo que te atrae...",
  profile_city: "Ciudad", profile_city_placeholder: "Tu ciudad", profile_age: "Edad", profile_experience: "Experiencia",
  profile_department: "Departamento", profile_department_unset: "No especificado",
  profile_region: "Región", profile_region_unset: "No especificado",
  profile_looking_for: "Busco", profile_interests: "Intereses", profile_interests_add: "Añadir...",
  profile_boundaries: "Mis límites y palabras seguras",
  profile_boundaries_placeholder: "Lo que no deseas, tus límites claros, tu palabra de seguridad...",
  profile_boundaries_hint: "Tus límites son visibles para otros miembros y serán respetados.",
  profile_privacy: "Privacidad",
  profile_visible: "Visible en el directorio", profile_visible_desc: "Desactiva para ocultar tu perfil.",
  profile_show_age: "Mostrar mi edad", profile_show_age_desc: "Tu edad será visible en tu perfil.",
  profile_allow_messages: "Aceptar mensajes privados", profile_allow_messages_desc: "Permite que otros miembros te escriban.",
  profile_save: "Guardar mi perfil", profile_saving: "Guardando...", profile_saved: "¡Perfil guardado!",

  looking_discussions: "Conversaciones", looking_friendship: "Amistad libertina", looking_soft: "Encuentros suaves",
  looking_parties: "Fiestas privadas", looking_couple: "Plan pareja", looking_solo: "Plan solo",
  looking_swinging: "Intercambio", looking_melangisme: "Intercambio suave", looking_voyeur: "Voyeurismo/Exhib",
  looking_bdsm: "BDSM", looking_poly: "Poliamor", looking_clubs: "Salidas a clubs",

  encounters_title: "Encuentros", encounters_desc: "Propón o únete a eventos.",
  encounters_propose: "+ Proponer", encounters_new: "Nueva propuesta",
  encounters_title_placeholder: "Título (ej: Fiesta libertina suave en Madrid)",
  encounters_desc_placeholder: "Describe el evento, el ambiente, tus expectativas...",
  encounters_category: "Categoría", encounters_who: "Quién puede unirse",
  encounters_city: "Ciudad", encounters_date: "Fecha y hora", encounters_max: "Máx. participantes",
  encounters_location: "Lugar (nombre del club, dirección, enlace...)",
  encounters_dresscode: "Código de vestimenta (opcional)", encounters_online: "En línea",
  encounters_rules: "Reglas del evento (opcional)", encounters_publish: "Publicar propuesta",
  encounters_creating: "Creando...", encounters_created: "¡Propuesta creada!",
  encounters_join: "Unirse →", encounters_join_placeholder: "Preséntate brevemente...",
  encounters_request_sent: "¡Solicitud enviada!", encounters_empty: "No hay encuentros por el momento.",
  encounters_open: "Abierto", encounters_full: "Completo",
  encounters_places: "{count}/{max} plazas", encounters_by: "por {name} · {date}",
  encounters_date_flexible: "Fecha flexible",

  cat_all: "Todas", cat_soiree: "Fiesta privada", cat_club: "Club", cat_meetup: "Encuentro",
  cat_afterwork: "After-work", cat_sauna: "Sauna / Spa", cat_voyage: "Viaje", cat_weekend: "Fin de semana",
  cat_online: "En línea", cat_couple_seek: "Busca pareja", cat_soft: "Suave / Descubrimiento",
  cat_discussion: "Conversación", cat_other: "Otro",

  who_all: "Abierto a todos", who_couples: "Solo parejas", who_men: "Solo hombres",
  who_women: "Solo mujeres", who_couples_women: "Parejas y mujeres", who_verified: "Perfiles verificados",

  places_title: "Lugares", places_desc: "Lugares libertinos recomendados por la comunidad.",
  places_add: "+ Añadir", places_suggest: "Sugerir un lugar", places_name: "Nombre del lugar",
  places_name_desc: "Describe el lugar, el ambiente, qué lo hace especial...",
  places_category: "Categoría", places_city: "Ciudad",
  places_department: "Departamento", places_department_select: "Seleccionar...",
  places_region: "Región", places_region_auto: "Auto", places_region_all: "Todo el país",
  places_price: "Precio", places_address: "Dirección completa (opcional)", places_website: "Sitio web (opcional)",
  places_features: "Equipamientos", places_submit: "Enviar", places_submitting: "Enviando...",
  places_submitted: "¡Lugar enviado!", places_empty: "No se encontraron lugares.",
  places_reviews: "opiniones", places_review_cta: "Dar mi opinión →",
  places_review_general: "General", places_review_ambiance: "Ambiente",
  places_review_respect: "Respeto", places_review_hygiene: "Higiene",
  places_review_placeholder: "Tu experiencia...", places_review_publish: "Publicar",
  places_review_published: "¡Opinión publicada!", places_verified: "✓ Verificado",
  places_search_placeholder: "Buscar por ciudad...",

  pcat_all: "Todos", pcat_club: "Club libertino", pcat_sauna: "Sauna / Spa", pcat_bar: "Bar",
  pcat_hotel: "Hotel", pcat_beach: "Playa / Naturaleza", pcat_camping: "Camping",
  pcat_restaurant: "Restaurante", pcat_association: "Asociación", pcat_boutique: "Tienda",
  pcat_online: "En línea", pcat_other: "Otro",

  price_unset: "No especificado", price_free: "Gratis", price_low: "€ (< 30€)", price_mid: "€€ (30-80€)", price_high: "€€€ (> 80€)",

  messages_title: "Mensajes", messages_desc: "Tus conversaciones privadas y discretas.",
  messages_empty: "No hay conversaciones.", messages_go_directory: "Ir al directorio →",
  messages_conversation: "Conversación",
  messages_start: "Inicio de la conversación. Sé respetuoso/a y amable.",
  messages_placeholder: "Tu mensaje...", messages_not_allowed: "Este miembro no acepta mensajes privados.",
  messages_moderation: "Mensaje no conforme a la carta.",

  premium_title: "Hazte Premium", premium_desc: "Desbloquea todas las funciones.",
  premium_current: "Actual", premium_choose: "Elegir {name}", premium_manage: "Gestionar suscripción",
  premium_redirecting: "Redirigiendo...",
  premium_success: "¡Bienvenido/a al plan {plan}!",
  premium_footer: "Pago seguro con Stripe · Cancela cuando quieras · Sin compromiso",
  premium_active_until: "Tu suscripción {name} está activa hasta el {date}.",
  plan_free: "Gratis", plan_premium: "Premium", plan_vip: "VIP", plan_month: "/mes",

  photos_drop: "Haz clic o arrastra una imagen (JPG, PNG, WebP · máx. 5 MB)",
  photos_count: "{current}/{max} fotos", photos_uploading: "Subiendo...",
  photos_limit: "Límite de {max} fotos alcanzado (plan {plan}).",
  photos_confirm_delete: "¿Eliminar esta foto?",

  visitors_title: "Quién visitó mi perfil",
  visitors_count: "visitas recientes",
  visitors_upsell: "Pasa a Premium para ver quién se interesa por ti.",
  visitors_none: "Sin visitas recientes.",
  nav_pro: "Pro",
  nav_visitors: "Visitantes",
  pro_title: "Dashboard Pro",
  pro_desc: "Gestiona tus locales reclamados.",
  pro_claim: "Es mi establecimiento",
  pro_no_places: "Ningún local reclamado.",
  pro_pending: "Solicitudes pendientes",
  spotlight_label: "Spotlight",
  spotlight_buy: "⭐ Boost 24h — 2,99€",
  spotlight_active: "Destacado",

};

export default es;
